import { render, staticRenderFns } from "./WelcomeTexts.vue?vue&type=template&id=52318029&scoped=true"
import script from "./WelcomeTexts.vue?vue&type=script&lang=js"
export * from "./WelcomeTexts.vue?vue&type=script&lang=js"
import style0 from "./WelcomeTexts.vue?vue&type=style&index=0&id=52318029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52318029",
  null
  
)

export default component.exports